export default {
  noActiveRecipe: 'Brak aktywnej receptury na tym piecu.',
};
